var _rect, _rect2, _rect3, _rect4, _rect5, _polygon, _polygon2, _polygon3, _polygon4, _rect6, _rect7, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoDataHubWhite = function SvgLogoDataHubWhite(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 264 120",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 178.869,
    y: 30.897,
    width: 6.5493,
    height: 32.7466,
    fill: "#fffffd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 207.2494,
    y: 30.897,
    width: 6.5493,
    height: 32.7466,
    fill: "#fffffd"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 227.5211,
    y: 29.899,
    width: 7.0381,
    height: 52.3946,
    fill: "#fffffd"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 113.0349,
    y: 15.1786,
    width: 32.1519,
    height: 89.8193,
    fill: "#f1a91d"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 70.3373,
    y: 15.1786,
    width: 31.4701,
    height: 89.8193,
    fill: "#f1a91d"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "62.852 119.968 47.883 119.968 47.883 104.998 51.625 104.998 51.625 116.225 62.852 116.225 62.852 119.968",
    fill: "#fdfdfc"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "47.883 15.179 47.883 0.209 62.852 0.209 62.852 3.951 51.625 3.951 51.625 15.179 47.883 15.179",
    fill: "#fdfdfc"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "167.642 15.179 167.642 0.209 152.672 0.209 152.672 3.951 163.899 3.951 163.899 15.179 167.642 15.179",
    fill: "#fffffd"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "167.642 104.998 167.642 119.968 152.672 119.968 152.672 116.225 163.899 116.225 163.899 104.998 167.642 104.998",
    fill: "#fffffd"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5795,
    y: 55.0798,
    width: 100.3649,
    height: 8.7509,
    fill: "#fcd479"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0.166,
    y: 29.899,
    width: 6.5493,
    height: 52.3946,
    fill: "#fdfdfc"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178.869,67.0118h6.5493a11.1885,11.1885,0,0,0,21.8311,0h6.5493a17.6208,17.6208,0,0,1-34.93,0Z",
    fill: "#fffffd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M237.8716,29.899h10.9155c8.7324,0,13.0986,6.5493,13.0986,13.0986S257.52,56.0963,248.7871,56.0963H237.8716V49.5469h10.9155a6.5493,6.5493,0,0,0,0-13.0986H237.8716Z",
    fill: "#fffffd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4578,29.899h6.5493c15.2818,0,19.648,13.0986,19.648,26.1973s-4.3662,26.1972-19.648,26.1972H10.4578V75.7442h6.5493c6.5494,0,13.0987-4.3662,13.0987-19.6479s-6.5493-19.648-13.0987-19.648H10.4578Z",
    fill: "#fdfdfc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M237.8716,82.2935h10.9155c10.9155,0,15.2817-7.6877,15.2817-15.2817S257.52,51.73,248.7871,51.73H237.8716v6.5494h10.9155c6.5493,0,8.7324,4.3662,8.7324,8.7324,0,4.031-2.1831,8.7324-8.7324,8.7324H237.8716Z",
    fill: "#fffffd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoDataHubWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logoDataHubWhite.cdfce80ddb14fd0b471ab83bcae226d8.svg";